import { Result } from '@standardnotes/domain-core';
import { CreatePayload, PayloadEmitSource, PayloadSource } from '@standardnotes/models';
import { Uuids } from '@standardnotes/utils';
export class RemoveItemsFromMemory {
    constructor(storage, items, payloads) {
        this.storage = storage;
        this.items = items;
        this.payloads = payloads;
    }
    async execute(items) {
        this.items.removeItemsFromMemory(items);
        const rawPayloads = await this.storage.getRawPayloads(Uuids(items));
        const encryptedPayloads = rawPayloads.map((payload) => CreatePayload(payload, PayloadSource.LocalDatabaseLoaded));
        await this.payloads.emitPayloads(encryptedPayloads, PayloadEmitSource.LocalDatabaseLoaded);
        return Result.ok();
    }
}
